import OnDemandDevelopers from "../on-demand-developers";
import ProjectByEquity from "../project-by-equity";
import FullProjectDevelopment from "../full-project-development";
import WhatServices from "../what-services";
import Confirmation from "../confirmation";
import NavBar from "../nav-bar";
// import Intro from "../Intro";
import OurServices from "../our-services";
// import SeeOurWork from "../see-our-work";
// import ImpactAcrossIndustries from "../impact-across-industries";
// import WhatMakeUsDifferent from "../what-make-us-different";
// import WhatOurClientSays from "../what-our-client-says";
// import MeetOurTeam from "../meet-our-team";
// import AboutUs from "../about-us";
import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumBold,
    CustomLabelMediumRegular,
    // CustomLabelMediumRegularRedHatInto,
    // CustomLabelXSmallRegular
} from "../common/CustomLabel";
import Box from "@mui/material/Box/Box";
import IPHONE151 from "../../assets/images/iPhone 15 Pro-1.png";
import ContactUs from "../contact-us";
import Footer from "../footer";
import React, {useRef, useState} from "react";
// import {useMediaQuery} from "@mui/material";
// import createTheme from "@mui/material/styles/createTheme";
import IntroDetails from "../intro-details";
// import WorkDetails from "../work-details";
// import PROJECT1 from "../../assets/images/project_1.png";
// import PROJECT2 from "../../assets/images/project2.png";
// import PROJECT3 from "../../assets/images/project3.png";
// import WorkCard from "../card-work";
import OurTeam from "../our-team";
// import TEAM_MEMBER from "../../assets/images/team-member.png";
// import TEAM_MEMBER2 from "../../assets/images/team-member2.png";
import HAMZA from "../../assets/team/hamza.jpg";
import NAEEM from "../../assets/team/naeem.jpg";
import ETHAN from "../../assets/team/ethan.jpg";
import ABDULLAH from "../../assets/team/abdullah.jpg";
import JANNAT from "../../assets/team/jannat.jpg";
import ASAD from "../../assets/team/asad.jpg";
import ARSLAN from "../../assets/team/arslan.jpg";
import IMRAAN from "../../assets/team/imran.jpg";
import IJLAL from "../../assets/team/ijlal.jpg";
import ZOHAIB from "../../assets/team/zohaib.jpg";
import SUMMIYA from "../../assets/team/summiya.jpg";
import AROOBA from "../../assets/team/arooba.png";
import FATIMA from "../../assets/team/fatima.jpg";
import UMER from "../../assets/team/umer.png";
// import SHUJA from "../../assets/team/shuja.png";
import ABDULSALAM from "../../assets/team/abdulSalam.png";
import ADEEL from "../../assets/team/adeel.png";

// const theme = createTheme({
//     breakpoints: {
//         values: {
//             xs: 0,
//             sm: 710,
//             md: 950,
//             lg: 1300,
//             xl: 1350,
//         },
//     },
// });


// Carousel settings for react-slick
// var settings_our_work = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     initialSlide: 0,
//     adaptiveHeight: true,
//     responsive: [

//         {
//             breakpoint: 1300, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },

//         {
//             breakpoint: 1200, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },
//         {
//             breakpoint: 1024, // Large screens
//             settings: {
//                 slidesToShow: 2,
//             },
//         },
//         {
//             breakpoint: 700, // Large screens
//             settings: {
//                 slidesToShow: 1.5,
//             },
//         },
//         {
//             breakpoint: 480, // Mobile
//             settings: {
//                 slidesToShow: 1.2,
//             },
//         },
//     ],
// };


// // Carousel settings for react-slick
// var settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     initialSlide: 0,
//     adaptiveHeight: true,
//     responsive: [
//         {
//             breakpoint: 1024, // Large screens
//             settings: {
//                 slidesToShow: 2,
//             },
//         },
//         {
//             breakpoint: 480, // Mobile
//             settings: {
//                 slidesToShow: 1.2,
//             },
//         },
//     ],
// };


// // Carousel settings for react-slick
// var profile_carousel_settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     initialSlide: 0,
//     adaptiveHeight: true,
//     responsive: [
//         {
//             breakpoint: 1400, // Large screens
//             settings: {
//                 slidesToShow: 3.5,
//             },
//         },
//         {
//             breakpoint: 1200, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },
//         {
//             breakpoint: 1024, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },
//         {
//             breakpoint: 680, // Mobile
//             settings: {
//                 slidesToShow: 1.5,
//             },
//         },
//     ],
// };


const OurTeamDetails = () => {

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [showFullProject, setShowFullProject] = useState(false);
    const [showOnDemandDevelopers, setShowOnDemandDevelopers] = useState(false);
    const [showProjectByEquity, setShowProjectByEquity] = useState(false);
    const [showWhatServices, setShowWhatService] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);


    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const testimonalsRef = useRef(null);
    const partnersRef = useRef(null);
    const contactUsRef = useRef(null);

    const BoardMembers = {
        title: "Board Team",
        description: "Guiding Ostryx with expertise in technology, strategy, and innovation, our leadership team is dedicated to shaping a successful future.",
        developers: [
            {img: HAMZA, name: "Muhammad Hamza", role: "CEO & Co-Founder"},
            {img: NAEEM, name: "Naeeem Qureshi", role: "COO & Co-Founder"},
            {img: ETHAN, name: "Ethan Karian", role: "CBDO & Co-Founder"}
        ]
    }



    const ProjectManagers = {
        title: "Business Development Team",
        description:"With years of experience in business growth, our Business Development Team builds strong partnerships and expands opportunities to keep OSTRYX moving forward.",
        developers: [
            {img: ETHAN, name: "Ethan Karian", role: "Chief Business Development Officer"},
            {img: JANNAT, name: "OBI", role: "Business Development Manager"},
            {img: SUMMIYA, name: "Summiya", role: "Business Developer"}

        ]
    }

    const ProjectDevelopment = {
        title: "Project Development Team",
        description:"Our Project Development Team specializes in web, admin panel, and application development, delivering high-quality, Customized solutions from planning to deployment with precision and innovation.",
        developers: [
            {img: NAEEM, name: "Naeeem Qureshi", role: "COO"},
            {img: ABDULLAH, name: "Abdullah", role: "CTO"},
        ]
    }
    const ProjectDevelopment1 = {
        developers: [
            {img: AROOBA, name: "Arooba", role: "Jr. Brand Identity Designer"},
            {img: ZOHAIB, name: "Zohaib", role: "Sr. Brand Identity Designer"},
            {img: ARSLAN, name: "Arslan", role: "Sr. Product Designer"},
        ]
    }
    const ProjectDevelopment2 = {
        developers: [
            {img: FATIMA, name: "Fatima", role: "Sr. Content Strategist"},
            {img: IMRAAN, name: "Imran", role: "Search Engine Strategist"},
        ]
    }
    const ProjectDevelopment3 = {
        developers: [
            {img: ASAD, name: "Asad Ullah", role: "Backend Engineer"},
            {img: IJLAL, name: "Ijlal", role: "Front End Developer"},
        ]
    }

    const ProjectDevelopment4 = {
        developers: [
            {img: ABDULSALAM, name: "Abdul Salam", role: "Native Engineer (Kotlin + Swift)"},
            {img: UMER, name: "Umer", role: "Flutter Developer"},
            // {img: SHUJA, name: "Shuja", role: "React Native Developer"},
        ]
    }
    const ProjectDevelopment5 = {
        developers: [
            {img: ADEEL, name: "Adeel", role: "Quality Assurance"},
        ]
    }



    // const FrontEndDevelopers = {
    //     title: "Front-End Developers",
    //     description:"Creating visually stunning and seamless user experiences, our front-end developers specialize in modern frameworks and responsive design.",
    //     developers: [
    //         {img: TEAM_MEMBER, name: "Autumn Phillips", role: "Senior Project Manager"},
    //         {img: TEAM_MEMBER2, name: "Stephanie Sharkey", role: "Junior Project Manager"},
    //         {img: TEAM_MEMBER, name: "Ricky Smith", role: "Junior Project Manager"}

    //     ]
    // }



    // const BackendDevelopers = {
    //     title: "Back-End Developers",
    //     description:"Building the foundation of high-performing applications, our back-end developers ensure security, efficiency, and scalability.",
    //     developers: [
    //         {img: TEAM_MEMBER, name: "Autumn Phillips", role: "Senior Project Manager"},
    //         {img: TEAM_MEMBER2, name: "Stephanie Sharkey", role: "Junior Project Manager"},
    //         {img: TEAM_MEMBER, name: "Ricky Smith", role: "Junior Project Manager"}

    //     ]
    // }


    // const MobileAppDevelopers = {
    //     title: "Mobile App Developers",
    //     description:"Delivering seamless mobile experiences, our mobile developers craft high-performance apps for iOS and Android.",
    //     developers: [
    //         {img: TEAM_MEMBER, name: "Autumn Phillips", role: "Senior Project Manager"},
    //         {img: TEAM_MEMBER2, name: "Stephanie Sharkey", role: "Junior Project Manager"},
    //         {img: TEAM_MEMBER, name: "Ricky Smith", role: "Junior Project Manager"}

    //     ]
    // }


    return (
        <Grid style={{width: "100vw", height: "100vh", overflowX: "hidden",}}>

            {
                showOnDemandDevelopers && <OnDemandDevelopers setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                                              setShowConfirmation={setShowConfirmation}
                />
            }

            {
                showProjectByEquity && <ProjectByEquity setShowProjectByEquity={setShowProjectByEquity}
                                                        setShowConfirmation={setShowConfirmation}/>
            }


            {
                showFullProject && <FullProjectDevelopment setShowFullProject={setShowFullProject}
                                                           setShowConfirmation={setShowConfirmation}/>
            }


            {
                showWhatServices &&
                <WhatServices setShowWhatService={setShowWhatService} setShowFullProject={setShowFullProject}
                              setShowProjectByEquity={setShowProjectByEquity}
                              setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            }


            {
                showConfirmation && <Confirmation setShowConfirmation={setShowConfirmation}/>
            }

            <NavBar isMenuClicked={isMenuClicked} serviceRef={serviceRef} portfolioRef={portfolioRef}
                    testimonalsRef={testimonalsRef} partnersRef={partnersRef} setIsMenuClicked={setIsMenuClicked}
                    contactUsRef={contactUsRef}
                    setShowWhatService={setShowWhatService}/>


            <IntroDetails title={"Our Team - The Backbone of Our Success"}
                          hideSearch={true}
                          description={`Behind every success story is a team that makes it happen. Get to know the talented individuals 
                                        who bring creativity, dedication, and expertise to every project. Together, we innovate, inspire, 
                                        and exceed expectations.`}
            />

            <Grid container justifyContent={"center"}>
                <Grid item container xs={11} md={9.5}>
                    <OurTeam {...BoardMembers}/>


                    <OurTeam {...ProjectManagers}/>


                    <OurTeam {...ProjectDevelopment}/>

                    <OurTeam {...ProjectDevelopment1}/>
                    <OurTeam {...ProjectDevelopment2}/>
                    <OurTeam {...ProjectDevelopment3}/>
                    <OurTeam {...ProjectDevelopment4}/>
                    <OurTeam {...ProjectDevelopment5}/>
                    {/* <OurTeam {...FrontEndDevelopers}/> */}


                    {/* <OurTeam {...BackendDevelopers}/> */}



                    {/* <OurTeam {...MobileAppDevelopers}/> */}

                </Grid>
            </Grid>


            <OurServices serviceRef={serviceRef} setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                         setShowWhatService={setShowWhatService}
                         setShowFullProject={setShowFullProject}
                         setShowProjectByEquity={setShowProjectByEquity}/>


            <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}}} justifyContent={"center"}>

                <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                    <CustomLabelMediumBold text={"Discuss Your Project with #1 Software Development Company USA "} color={"#5E17EB"}/>
                </Grid>

                <Grid item container xs={10} style={{marginTop: "5px"}} justifyContent={"center"}>
                    <CustomLabelMediumRegular normal={false}
                                              text={"Got an Idea? Let’s Build It Together — Contact Us for Expert Development Solutions.  "}
                    />
                </Grid>


                <Grid item container xs={12}  justifyContent={"space-between"}
                      sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "20px", lg: "60px"}}}>


                    <Grid item xs={12} lg={4.8}
                          sx={{maxHeight: "100%", width: "100%", padding: "0px", position: "relative"}}>
                        <Box component={"img"} src={IPHONE151} alt={"OSTRYX"}
                             sx={{height: {lg: "100%"}, width: {xs: "100%", lg: "100%", xlg: "auto"}}}/>
                    </Grid>

                    <ContactUs setShowConfirmation={setShowConfirmation}/>


                </Grid>

                <div ref={contactUsRef} tabIndex={0}></div>

            </Grid>


            <Footer/>

        </Grid>
    )
}

export default OurTeamDetails;
